import * as RadixTabs from '@radix-ui/react-tabs';
import React from 'react';
import styled from 'styled-components';

type TabsProps = RadixTabs.TabsProps;

type TabsComponent = React.ForwardRefExoticComponent<
  TabsProps & React.RefAttributes<typeof RadixTabs.Root>
> & {
  Trigger: typeof TabsTrigger;
  Content: typeof TabsContent;
  List: typeof TabsList;
};
export const Tabs = React.forwardRef<
  React.ElementRef<typeof RadixTabs.Root>,
  TabsProps
>(({ children, ...rest }, forwardedRef) => {
  return (
    <TabsRoot ref={forwardedRef} {...rest}>
      {children}
    </TabsRoot>
  );
}) as TabsComponent;

const TabsRoot = styled(RadixTabs.Root)`
  display: grid;
`;

const TabsList = styled(RadixTabs.List)`
  display: flex;
  gap: 12px;
`;

Tabs.List = TabsList;

const TabsTrigger = styled(RadixTabs.Trigger)`
  background: ${({ theme }): string => theme.palette_blue_5};
  color: ${({ theme }): string => theme.palette_blue_100};
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  user-select: none;
  font-size: 14px;

  &:disabled {
    cursor: default;
    color: ${({ theme }): string => theme.palette_gray_60};
    background: ${({ theme }): string => theme.palette_gray_5};
  }

  &[data-state='active'] {
    background: ${({ theme }): string => theme.palette_blue_100};
    color: white;
  }

  &:focus {
    position: relative;
  }
`;

Tabs.Trigger = TabsTrigger;

const TabsContent = styled(RadixTabs.Content)``;

Tabs.Content = TabsContent;
